import React, {useState, useEffect} from "react";
import { Button, Card, Col, DatePicker, Divider, Input, Modal, PageHeader, Row, Select, Table, Tabs, Upload, message, notification } from 'antd'
import { PlusOutlined, CaretDownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { getDateFormat, getTime, get_url_params } from "../../utils/commonUtilities";
import editIcon from '../../Assets/images/edit-icon.svg'
import timelineIcon from '../../Assets/images/timeline.svg'
import checkCircle from '../../Assets/images/check-circle.svg'
import dayjs from "dayjs";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { updateBooking, updateBookingLoading } from "../../actions/bookingActions";
import { connect } from "react-redux";
import api from '../../utils/apiRoutes'
import Cookies from "js-cookie";
import Lottie from 'lottie-react'
import QueryAnimation from '../../Assets/animations/yes-no-animation.json'
import BackIcon from '../../Assets/images/back-icon.svg'

import './index.scss'
import ViewPdfModal from "../ViewPdfModal";

const EnhancementComponent = (props) => {

    // const {data} = props
    // console.warn({data})
    const dateFormat = 'DD-MMM-YYYY'
    const history = useHistory()
    const bookingId = get_url_params('id')
    const [pdfUrl, setPdfUrl] = useState('')
    const [tabIndex, setTabIndex] = useState('billClosure')
    const [isDisabled, setIsDisabled] = useState(false)
    const [openBillModal, setOpenBillModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [editQuery, setEditQuery] = useState(false)
    const [queryModal, setQueryModal] = useState(false)
    const [dischargeDocUrl, setDischargeDocUrl] = useState('')
    const [enhancementUrl, setEnhancementUrl] = useState('')
    const [data, setData] = useState(null)
    const [billFlag, setBillFlag] = useState(false)
    const [newBillData, setNewBillData] = useState({
        _id: '',
        alNumber: '',
        name: '',
        hospital: '',
        dod: '',
        totalBill: '',
        finalApproved: '',
        initialApproved: '',
        doa: '',
    })
    const [editBillData, setEditBillData] = useState({
        _id: '',
        alNumber: '',
        name: '',
        hospital: '',
        dod: '',
        totalBill: '',
        finalApproved: '',
        initialApproved: '',
        doa: '',
    })

    useEffect(() => {
        if(!bookingId || bookingId.length===0) {
            history.push('/dashboard')
        }
        const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get("token_medical_auth")}` } }
        const data = {
            booking_id: bookingId
        }
        api.booking.getBookingById(data, headers)
        .then(res => {
            const booking = res.data[0].data[0]
            booking.timeLine = booking.timeLine ?  booking.timeLine.sort((a,b) => b.date - a.date) : []
            // console.warn("Data here>> ",booking);
            let discharge = 0; let enhancement = 0
            booking.timeLine.map(item => {
                if(discharge==0) {
                    if(item.task === "Discharge" && item.desc === "Discharge Document Received" && item.docURL) {
                        discharge = 1
                        setDischargeDocUrl(item.docURL)
                    }
                }
                if(enhancement===0) {
                    if(item.task === "Processing" && item.desc === "Enhancement Letter Received" && item.docURL) {
                        enhancement = 1
                        setEnhancementUrl(item.docURL)
                    }
                }
            })
            setData(booking)
            setBillFlag(booking.paymentDetails.billFlag)
            setNewBillData({
                _id: booking._id,
                alNumber: booking.alNumber ? booking.alNumber : '',
                name: booking.patientName ? booking.patientName : '',
                hospital: booking.professionalName,
                dod: booking.dod ? booking.dod : '',
                totalBill: booking.paymentDetails.totalBill ? booking.paymentDetails.totalBill : '',
                finalApproved: booking.paymentDetails.finalApproved ? booking.paymentDetails.finalApproved : '',
                initialApproved: booking.paymentDetails.initialApproved ? booking.paymentDetails.initialApproved : '',
                doa: booking.doa ? booking.doa : '',
            })
            setEditBillData({
                _id: booking._id,
                alNumber: booking.alNumber ? booking.alNumber : '',
                name: booking.patientName ? booking.patientName : '',
                hospital: booking.professionalName,
                dod: booking.dod ? booking.dod : '',
                totalBill: booking.paymentDetails.totalBill ? booking.paymentDetails.totalBill : '',
                finalApproved: booking.paymentDetails.finalApproved ? booking.paymentDetails.finalApproved : '',
                initialApproved: booking.paymentDetails.initialApproved ? booking.paymentDetails.initialApproved : '',
                doa: booking.doa ? booking.doa : '',
            })
            if(booking.paymentDetails?.totalBill === undefined) {
                setIsDisabled(true)
            }
            else if(booking.paymentDetails?.totalBill !== undefined) {
                setIsDisabled(Number(booking.paymentDetails?.totalBill)===0)
            }
        })
        .catch(err => {
            console.error(err)
        })
    },[bookingId, props.updateBookingRet])

    useEffect(() => {
        if(props.updateBookingRet) {
            // console.warn(props.updateBookingRet);
            if(props.updateBookingRet.success) {
                let booking = props.updateBookingRet.data
                // console.warn("update booking: ", booking)
                setEditModal(false)
                setOpenBillModal(false)
            } else {
                openNotificationWithIcon('error','Update Failed',"Couldn't update the data" )
            }
        }
    }, [props.updateBookingRet])

    const openNotificationWithIcon = (type, message, description) => {
        notification[type]({
          message: message,
          description:
            description,
        });
    };

    const handleSaveBill = () => {
        if(newBillData.totalBill === '' || newBillData.totalBill === '0') {
            openNotificationWithIcon('error', 'Error', 'Total Bill cannot be empty or 0')
            return
        }
        if(editBillData.totalBill < 0 || newBillData.totalBill < 0) {
            openNotificationWithIcon('error', 'Error', 'Total Bill cannot be negative')
            return
        }
        if(newBillData.dod === '') {
            openNotificationWithIcon('error', 'Error', 'Date of Discharge cannot be empty')
            return
        }
        if(newBillData.doa!=='' && dayjs(newBillData.dod).isBefore(newBillData.doa)) {
            notification.error({
                message: 'Error',
                description: <><p style={{marginBottom:'5px'}}>Date of discharge cannot be before date of date of admission.</p><p style={{margin:'0'}}>Date of admission: <span style={{fontWeight:'bolder'}}>{newBillData.doa}</span></p></>
            })
            return
        }
        props.updateBooking({
            bookingId: newBillData._id,
            billFlag: true,
            // userName: newBillData.name,
            dod: newBillData.dod,
            totalBill: newBillData.totalBill,
            totalRoomRent: (data?.doa && newBillData.dod && data?.paymentDetails?.roomRent) ? (Number((dayjs(newBillData.dod).diff(data?.doa, 'day')) * data?.paymentDetails?.roomRent) || 0) : '0'
            // paymentDetails: {...data.paymentDetails, billFlag: true}
        })
    }

    const handleEditBill = () => {
        if(editBillData.totalBill === '' || editBillData.totalBill === '0') {
            openNotificationWithIcon('error', 'Error', 'Total Bill cannot be empty or 0')
            return
        }
        if(editBillData.dod === '') {
            openNotificationWithIcon('error', 'Error', 'Date of Discharge cannot be empty')
            return
        }
        if(editBillData.totalBill < 0) {
            openNotificationWithIcon('error', 'Error', 'Total Bill cannot be negative')
            return
        }
        if(editBillData.doa!=='' &&  dayjs(editBillData.dod).isBefore(editBillData.doa)) {
            notification.error({
                message: 'Error',
                description: <><p style={{marginBottom:'5px'}}>Date of discharge cannot be before date of date of admission.</p><p style={{margin:'0'}}>Date of admission: <span style={{fontWeight:'bolder'}}>{editBillData.doa}</span></p></>
            })
            return
        }
        props.updateBooking({
            bookingId: editBillData._id,
            billFlag: true,
            // userName: editBillData.userName,
            dod: editBillData.dod,
            totalBill: editBillData.totalBill,
            totalRoomRent: (data?.doa && editBillData.dod && data?.paymentDetails?.roomRent) ? (Number((dayjs(editBillData.dod).diff(data?.doa, 'day')) * data?.paymentDetails?.roomRent) || 0) : 0
            // finalBillStatus: data.paymentDetails.finalBillStatus
        })
    }

    return (
    <>
        <div className="booking-enhancement-containers">
            {tabIndex==='billClosure' && <Button className="add-new-bill-closure" disabled={!isDisabled} icon={<PlusOutlined style={{color:'#FFFFFF'}}/>} onClick={()=>setOpenBillModal(true)}>Bill Closure</Button>}
            <div className="enhancement-heading-container">
                <h3 className={`${tabIndex==='billClosure' && 'active'}`} onClick={()=>setTabIndex('billClosure')}>Bill Closure</h3>
                <h3 className={`${tabIndex==='finalBill' && 'active'}`} onClick={()=>setTabIndex('finalBill')}>Final Bill Preview</h3>
            </div>
            {(tabIndex==='billClosure' && !isDisabled) && <div className="final-bill-closure-container">
                <span>Final Bill Closure</span>
                <div className="bill-closure-table">
                    <div className="bill-closure-table-scroll">
                        <div className="closure-table-head" style={{margin:'0', borderRadius:'10px 10px 0 0', backgroundColor:'#02922A'}}>
                            <Row gutter={24}>
                                <Col span={3}>
                                    <h5 style={{paddingLeft:'12px'}}>AL No.</h5>
                                </Col>
                                <Col span={3}>
                                    <h5>Name</h5>
                                </Col>
                                <Col span={4}>
                                    <h5>Hospital</h5>
                                </Col>
                                <Col span={3}>
                                    <h5>DOD</h5>
                                </Col>
                                <Col span={3}>
                                    <h5>Initial Approval</h5>
                                </Col>
                                <Col span={3}>
                                    <h5>Final Approval</h5>
                                </Col>
                                <Col span={2}>
                                    <h5>Final Bill</h5>
                                </Col>
                                <Col span={2}>
                                    <h5>Bill Status</h5>
                                </Col>
                                <Col style={{display:'flex',alignItems:'center'}}>
                                    <img src={editIcon} alt="edit" style={{filter:'invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(102%) contrast(104%)'}} onClick={()=>{setEditModal(true); setEditQuery(true)}}/>
                                </Col>
                            </Row>
                        </div>
                        <div className="closure-table-body" style={{margin:'0', borderRadius:'0 0 10px 10px', backgroundColor:'#FFFFFF'}}>
                            <Row gutter={24}>
                                <Col span={3}>
                                    <p style={{paddingLeft:'12px', wordBreak:'break-all'}}>{data?.alNumber ? data?.alNumber : 'Not Updated Yet'}</p>
                                </Col>
                                <Col span={3}>
                                    <p style={{wordBreak:'break-all'}}>{data?.patientName}</p>
                                </Col>
                                <Col span={4}>
                                    <p style={{wordBreak:'break-all'}}>{data?.professionalName}</p>
                                </Col>
                                <Col span={3}>
                                    <p style={{wordBreak:'break-all'}}>{data?.dod}</p>
                                </Col>
                                <Col span={3}>
                                    <p style={{wordBreak:'break-all'}}>{ data?.paymentDetails?.initialApproved ? (isNaN(data?.paymentDetails?.initialApproved) ? '-' : `₹ ${Number(data?.paymentDetails?.initialApproved).toLocaleString('en-IN')}`) : '-'}</p>
                                </Col>
                                <Col span={3}>
                                    <p style={{wordBreak:'break-all'}}>{ data?.paymentDetails?.finalApproved || data?.paymentDetails?.finalApproved == 0 ? (isNaN(data?.paymentDetails?.finalApproved) ? '-' : `₹ ${Number(data?.paymentDetails?.finalApproved).toLocaleString('en-IN')}`) : '-'}</p>
                                </Col>
                                <Col span={2}>
                                    <p style={{wordBreak:'break-all'}}>{ data?.paymentDetails?.finalBill || data?.paymentDetails?.finalBill == 0? (isNaN(data?.paymentDetails?.finalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.finalBill).toLocaleString('en-IN')}`) : '-'}</p>
                                </Col>
                                <Col span={2} style={{display:'flex',alignItems:'center', justifyContent:'space-between'}}>
                                    <p className='status' style={{backgroundColor:`${data?.paymentDetails?.finalBillStatus==='YES' ? '#30C118' : '#F93C23'}`, wordBreak: 'break-all', fontSize:'0.85rem'}}>{data?.paymentDetails?.finalBillStatus}</p>
                                </Col>
                            </Row>
                            <Divider style={{margin:'0', borderBottom:'1px solid #ADA7A7'}}/>
                            <Row gutter={24}>
                                <Col span={24} style={{display:'flex',alignItems:'center', gap:'1.75rem'}}>
                                {(data?.paymentDetails?.finalBillStatus==='YES') && (<><p style={{paddingLeft:'12px', fontSize:'16px', fontWeight:'700'}}>Discharge Document</p>
                                {dischargeDocUrl ? <a onClick={()=>setPdfUrl(dischargeDocUrl)}>View</a> : <p>Not Uploaded Yet</p>}</>)}
                                {(data?.paymentDetails?.finalBillStatus!=='YES') && (<><p style={{paddingLeft:'12px', fontSize:'16px', fontWeight:'700'}}>Enhancement Letter</p>
                                {enhancementUrl ? <a onClick={()=>setPdfUrl(enhancementUrl)}>View</a> : <p>Not Uploaded Yet</p>}</>)}
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>

                {/* {(data?.paymentDetails.finalBillStatus!=='PENDING') && (<>
                    <span>Payment Status</span>
                    <div className="payment-table" style={{width:'60%'}}>
                    <div className="payment-table-heading">
                            <h3>Account Payment Closure</h3>
                        </div>
                        <div className="payment-table-head">
                            <Row gutter={24}>
                                <Col span={8} type='flex' align='middle'>
                                    <h2>Payment Date</h2>
                                </Col>
                                <Col span={8} type='flex' align='middle'>
                                    <h2>Final Pay Status</h2>
                                </Col>
                                <Col span={8} type='flex' align='middle'>
                                    <h2>UTR No.</h2>
                                </Col> */}
                                {/* <Col span={12} type='flex' align='middle'>
                                    <h2>Uploaded Payment Receipt</h2>
                                </Col> */}
                            {/* </Row>
                        </div>
                        <div className="payment-table-body">
                            <Row gutter={24}>
                                <Col span={8} type='flex' align='middle'>
                                    <p className="pay-date">{data?.paymentDetails?.paymentDate ? dayjs(data?.paymentDetails?.paymentDate*1000).format(dateFormat): "Not Updated Yet"}</p>
                                </Col>
                                <Col span={8} type='flex' align='middle'>
                                    <p className="pay-status" style={{backgroundColor:`${data?.paymentDetails?.paymentStatus==='DONE' ? '#30C118' : '#F93C23'}`}}>{data?.paymentDetails?.paymentStatus ? data?.paymentDetails?.paymentStatus : 'PENDING'}</p>
                                </Col>
                                <Col span={8} type='flex' align='middle'>
                                    <p className="utr-number">{data?.paymentDetails?.utr ? data?.paymentDetails?.utr : 'Not Updated Yet'}</p>
                                </Col> */}
                                {/* <Col span={12} type='flex' align='middle'>
                                    <p className="receipt">Payment Receipt <a href={`${data?.paymentDetails?.paymentReceipt?.docURL ? data?.paymentDetails?.paymentReceipt?.docURL : ''}`} target={`${data?.paymentDetails?.paymentReceipt?.docURL ? '_blank' : ''}`} onClick={(e)=>e.preventDefault()}>View</a></p>
                                </Col> */}
                            {/* </Row>
                        </div>
                    </div>
                </>)} */}
            </div>}
            {(tabIndex==='finalBill') && <div className="final-bill-preview-container">
                <Row gutter={24}>
                    <Col span={16}>
                        <div className="final-bill-preview">
                            <h2>Final Bill Preview</h2>
                            <div className="final-bill-preview-body">
                                <Row gutter={24}>
                                    <Col span={6}>
                                        <label className="label-text">AL Number</label>
                                        <p className="label-value">{data?.alNumber ? data?.alNumber : 'Not Updated Yet'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Name</label>
                                        <p className="label-value">{data?.patientName}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Hospital</label>
                                        <p className="label-value">{data?.professionalName ? data?.professionalName : '-'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Date of Discharge</label>
                                        <p className="label-value">{data?.dod ? data?.dod : 'Not Updated Yet'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={6}>
                                        <label className="label-text">Total Bill</label>
                                        <p className="label-value">{ data?.paymentDetails?.totalBill || data?.paymentDetails.totalBill == 0 ? (isNaN(data?.paymentDetails?.totalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.totalBill).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Discount Amount</label>
                                        <p className="label-value">{ data?.paymentDetails?.discount || data?.paymentDetails?.discount == 0 ? (isNaN(data?.paymentDetails?.discount) ? '-' : `₹ ${Number(data?.paymentDetails?.discount).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Final Bill</label>
                                        <p className="label-value">{ data?.paymentDetails?.finalBill || data?.paymentDetails?.finalBill == 0? (isNaN(data?.paymentDetails?.finalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.finalBill).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Final Approval</label>
                                        <p className="label-value">{ data?.paymentDetails?.finalApproved || data?.paymentDetails?.finalApproved == 0 ? (isNaN(data?.paymentDetails?.finalApproved) ? '-' : `₹ ${Number(data?.paymentDetails?.finalApproved).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={6}>
                                        <label className="label-text">PF Amount</label>
                                        <p className="label-value">{ data?.paymentDetails?.pfAmount || data?.paymentDetails?.pfAmount == 0 ? (isNaN(data?.paymentDetails?.pfAmount) ? '-' : `₹ ${Number(data?.paymentDetails?.pfAmount).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Payment to Hospital</label>
                                        <p className="label-value">{ data?.paymentDetails?.paymentToHospital || data?.paymentDetails?.paymentToHospital == 0 ? (isNaN(data?.paymentDetails?.paymentToHospital) ? '-' : `₹ ${Number(data?.paymentDetails?.paymentToHospital).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">Payment Date</label>
                                        <p className="label-value">{data?.paymentDetails?.paymentDate ? dayjs(data?.paymentDetails?.paymentDate*1000).format(dateFormat) : 'Not Updated Yet'}</p>
                                    </Col>
                                    <Col span={6}>
                                        <label className="label-text">UTR</label>
                                        <p className="label-value">{data?.paymentDetails?.utr ? data?.paymentDetails?.utr : 'Not Updated Yet'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Package</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.package || data?.paymentDetails?.package == 0 ? (isNaN(data?.paymentDetails?.package) ? '-' : `₹ ${Number(data?.paymentDetails?.package).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Consultation</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.cvc || data?.paymentDetails?.cvc == 0 ? (isNaN(data?.paymentDetails?.cvc) ? '-' : `₹ ${Number(data?.paymentDetails?.cvc).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Total Room Rent</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.totalRoomRent || data?.paymentDetails?.totalRoomRent == 0 ? (isNaN(data?.paymentDetails?.totalRoomRent) ? '-' : `₹ ${Number(data?.paymentDetails?.totalRoomRent).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                {data?.treatment === 'Surgical Management' && (
                                <>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">OT Charges</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.otCharges || data?.paymentDetails?.otCharges == 0 ? (isNaN(data?.paymentDetails?.otCharges) ? '-' : `₹ ${Number(data?.paymentDetails?.otCharges).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Surgeon</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.soa || data?.paymentDetails?.soa == 0 ? (isNaN(data?.paymentDetails?.soa) ? '-' : `₹ ${Number(data?.paymentDetails?.soa).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Anaesthetist</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.anesthetist || data?.paymentDetails?.anesthetist == 0 ? (isNaN(data?.paymentDetails?.anesthetist) ? '-' : `₹ ${Number(data?.paymentDetails?.anesthetist).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                </>
                                )}
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Investigation Charges</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.investigation ? (isNaN(data?.paymentDetails?.investigation) ? '-' : `₹ ${Number(data?.paymentDetails?.investigation).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Medicine & Consumables</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.medicineConsumables || data?.paymentDetails?.medicineConsumables == 0 ? (isNaN(data?.paymentDetails?.medicineConsumables) ? '-' : `₹ ${Number(data?.paymentDetails?.medicineConsumables).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Other Hospital Expenses</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.others || data?.paymentDetails?.others == 0 ? (isNaN(data?.paymentDetails?.others) ? '-' : `₹ ${Number(data?.paymentDetails?.others).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Divider style={{borderBottom:'1px solid #1C1C1C', margin:'0.25rem 0 1rem 0'}}/>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Total</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.totalBill || data?.paymentDetails.totalBill == 0 ? (isNaN(data?.paymentDetails?.totalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.totalBill).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Discount</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.discount || data?.paymentDetails?.discount == 0 ? (isNaN(data?.paymentDetails?.discount) ? '-' : `₹ ${Number(data?.paymentDetails?.discount).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">TDS Deductions</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.tdsDeductions || data?.paymentDetails?.tdsDeductions == 0 ? (isNaN(data?.paymentDetails?.tdsDeductions) ? '-' : `₹ ${Number(data?.paymentDetails?.tdsDeductions).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                                {/* <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">TDS Deductions</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.tdsDeduction ? (isNaN(data?.paymentDetails?.tdsDeduction) ? '-' : `₹ ${Number(data?.paymentDetails?.tdsDeduction).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row> */}
                                <Divider style={{borderBottom:'1px solid #1C1C1C', margin:'0.25rem 0 1rem 0'}}/>
                                <Row gutter={24}>
                                    <Col span={18}>
                                        <p className="label-value bill">Final Amount</p>
                                    </Col>
                                    <Col span={6}>
                                        <p className="label-value bill">{ data?.paymentDetails?.finalBill || data?.paymentDetails?.finalBill == 0? (isNaN(data?.paymentDetails?.finalBill) ? '-' : `₹ ${Number(data?.paymentDetails?.finalBill).toLocaleString('en-IN')}`) : '-'}</p>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div className='timeline-container'>
                            {/* <Button className='booking-view-doc-btn' onClick={() => setDocumentModal(true)} >View Documents</Button> */}
                            <Card className='booking-timeline-card enhancement-timeline' title={(<><img src={timelineIcon} alt='icon'/><p>Timeline</p></>)}>
                            {
                                data?.timeLine?.map((ele, idx) => (
                                <div className='booking-timeline-container' key={idx}>
                                    <div className='side-icons'>
                                    <img src={checkCircle} alt='circle'/>
                                    <div className='divider-vertical' style={{height:`${ele.docURL ? '60px' : '40px'}`}}></div>
                                    </div>
                                    <div>
                                    <p className='booking-timeline-stage'>{ ele.task }</p>
                                    <p className='booking-timeline-status'>{ ele.desc }</p>
                                    <span className='booking-timeline-time'>{getDateFormat(ele.date)}, {getTime(ele.date)}</span>
                                    { ele.docURL && <div className='booking-timeline-link'>
                                        <a onClick={()=>{setPdfUrl(ele.docURL)}}>View</a>
                                    </div>}
                                    </div>
                                </div>
                                ))
                            }
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>}
        </div>
        {pdfUrl && <ViewPdfModal openPDFModal={pdfUrl} pdfUrl={pdfUrl} setOpenPDFModal={setPdfUrl} />}
        <Modal
            width={1000}
            visible={openBillModal}
            onCancel={()=>setOpenBillModal(false)}
            onOk={()=>setOpenBillModal(false)}
            className="add-new-bill-closure-modal"
            title='Add Bill Closure'
        >
            <Row gutter={24}>
                <Col span={8}>
                    <label>AL No.</label>
                    <Input value={newBillData.alNumber} onChange={e=>setNewBillData({...newBillData, alNumber:e.target.value})} placeholder="Enter AL Number" className="bill-closure-input" disabled={true}/>
                </Col>
                <Col span={8}>
                    <label>Name</label>
                    <Input value={newBillData.name} onChange={e=>setNewBillData({...newBillData, name:e.target.value})} placeholder="Enter Name" className="bill-closure-input" disabled={true}/>
                </Col>
                <Col span={8}>
                    <label>Hospital</label>
                    <Input value={newBillData.hospital} placeholder="Enter Hospital Name" className="bill-closure-input" disabled={true}/>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={8}>
                    <label>Date of Discharge*</label>
                    <DatePicker className="bill-closure-input" value={newBillData.dod ? dayjs(newBillData.dod,dateFormat) : null} onChange={(date,dateString) => setNewBillData({...newBillData, dod:dateString})} format={dateFormat} getPopupContainer={trigger => trigger.parentElement} />
                </Col>
                <Col span={8}>
                    <label>Total Bill*</label>
                    <Input type="number" value={newBillData.totalBill} onChange={e=>setNewBillData({...newBillData, totalBill:e.target.value})} placeholder="₹ 00.00" className="bill-closure-input"/>
                </Col>
                <Col span={8}>
                    <label>Initial Approval</label>
                    <Input type="number" value={newBillData.initialApproved} onChange={e=>setNewBillData({...newBillData, initialApproved:e.target.value})} placeholder="₹ 00.00" className="bill-closure-input" disabled={true}/>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={8}>
                    <label>Final Approval</label>
                    <Input type="number" value={newBillData.finalApproved} onChange={e=>setNewBillData({...newBillData, finalApproved:e.target.value})} placeholder="₹ 00.00" className="bill-closure-input" disabled={true}/>
                </Col>
            </Row>
            <div className="footer-buttons">
                <Button className="cancel-button" onClick={()=>setOpenBillModal(false)}>Cancel</Button>
                <Button className="save-button" onClick={handleSaveBill}>Save</Button>
            </div>
        </Modal>
        <Modal
            width={1000}
            visible={editModal}
            onCancel={()=>setEditModal(false)}
            onOk={()=>setEditModal(false)}
            className="add-new-bill-closure-modal"
            title='Edit Bill Closure'
        >
            <Row gutter={24}>
                <Col span={8}>
                    <label>AL No.</label>
                    <Input value={editBillData.alNumber} onChange={e=>setEditBillData({...editBillData, alNumber:e.target.value})} placeholder="Enter AL Number" className="bill-closure-input" disabled={true}/>
                </Col>
                <Col span={8}>
                    <label>Name</label>
                    <Input value={editBillData.name} onChange={e=>setEditBillData({...editBillData, name:e.target.value})} placeholder="Enter Name" className="bill-closure-input" disabled={true}/>
                </Col>
                <Col span={8}>
                    <label>Hospital</label>
                    <Input value={editBillData.hospital} placeholder="Enter Hospital Name" className="bill-closure-input" disabled={true}/>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={8}>
                    <label>Date of Discharge*</label>
                    <DatePicker className="bill-closure-input" value={editBillData.dod ? dayjs(editBillData.dod,dateFormat) : null} onChange={(date,dateString) => setEditBillData({...editBillData, dod:dateString})} format={dateFormat} getPopupContainer={trigger => trigger.parentElement} />
                </Col>
                <Col span={8}>
                    <label>Total Bill*</label>
                    <Input type="number" value={editBillData.totalBill} onChange={e=>setEditBillData({...editBillData, totalBill:e.target.value})} placeholder="₹ 00.00" className="bill-closure-input"/>
                </Col>
                <Col span={8}>
                    <label>Initial Approval</label>
                    <Input type="number" value={editBillData.initialApproved} onChange={e=>setEditBillData({...editBillData, initialApproved:e.target.value})} placeholder="₹ 00.00" className="bill-closure-input" disabled={true}/>
                </Col>
            </Row>
            <Row gutter={24}>
                {/* <Col span={8}>
                    <label>Bill Status</label>
                    <p className="edits-bill-status" style={{backgroundColor:`${data?.paymentDetails?.finalBillStatus==='YES' ? '#30C118':'#F93C23'}`}}>{data?.paymentDetails?.finalBillStatus}</p>
                </Col> */}
                <Col span={8}>
                    <label>Final Approval</label>
                    <Input type="number" value={editBillData.finalApproved} onChange={e=>setEditBillData({...editBillData, finalApproved:e.target.value})} placeholder="₹ 00.00" className="bill-closure-input" disabled={true}/>
                </Col>
            </Row>
            {/* <Divider style={{borderBottom:'1px solid #AEAEAE', margin:'0 0 2.5rem 0'}}/>
            <Row gutter={24}>
                <Col span={8}>
                    <label>Change Bill Status</label>
                    <Select value={data?.paymentDetails?.finalBillStatus} onChange={e=>setData({...data, paymentDetails:{...data.paymentDetails,finalBillStatus:e}})} className="bill-closure-input selection-input" suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}>
                        <Select.Option value="YES">YES</Select.Option>
                        <Select.Option value="NO">NO</Select.Option>
                    </Select>
                </Col>
            </Row> */}
            <div className="footer-buttons">
                <Button className="cancel-button" onClick={()=>setEditModal(false)}>Cancel</Button>
                <Button className="save-button" onClick={handleEditBill}>Save</Button>
            </div>
        </Modal>
        <Modal
            width={700}
            open={billFlag}
            // onCancel={()=>setBillFlag(false)}
            onOk={()=>setBillFlag(false)}
            className="final-bill-query-modal"
        >
            <img src={BackIcon} alt="back" onClick={()=>{history.push(`/dashboard/booking/booking-details?id=${bookingId}`, {activeTab: '1'}); window.location.reload()}} className="bill-query-back-icon"/>
            <div className="success-gif">
                <div style={{display:'flex', flexDirection:'column'}}>
                    <div className="dots-pattern"></div>
                    <div className="dots-pattern"></div>
                    <div className="dots-pattern"></div>
                    <div className="dots-pattern"></div>
                </div>
                <Lottie animationData={QueryAnimation} className="success-gif-img"/>
                {/* <img src={require('../../Assets/images/bill-query-animation.gif')} alt="GIF" className="success-gif-img"/> */}
                <div style={{display:'flex', flexDirection:'column'}}>
                    <div className="dots-pattern"></div>
                    <div className="dots-pattern"></div>
                    <div className="dots-pattern"></div>
                    <div className="dots-pattern"></div>
                </div>
            </div>
            <div className="footer-container">
                <h2>Is this a Final Bill ?</h2>
                <div className="footer-btns">
                    <Button className="redirect-button yes" onClick={()=>{history.push(`/dashboard/final-bill/yes?id=${data?._id}&billFlag=${billFlag}`)}}>Yes</Button>
                    <Button className="redirect-button no" onClick={()=>{history.push(`/dashboard/final-bill/no?id=${data?._id}&billFlag=${billFlag}`)}}>No</Button>
                </div>
            </div>
        </Modal>
    </>
    )
}

const mapStateToProps = (state) => ({
    updateBookingLoadingFlag: state.bookingStore.updateBookingLoading,
    updateBookingRet: state.bookingStore.updateBookingRet,
});

export default connect(mapStateToProps, {
    updateBooking,
    updateBookingLoading
})(EnhancementComponent)